module.exports = __webpack_public_path__ + "static/media/workmethodtriangles.8d1717cd.svg";